import {
  GetPartnerConfigBuilder,
  UpdatePartnerConfigRequestBuilder,
} from '../notifications/notifications';

import Client from '../client';
// import {flattenObject} from '../helpers';

const token = localStorage.getItem('token') || '';

class PartnerConfigRepository {
  getPartnerConfig = async (actions: any) => {
    const makeRequest = new GetPartnerConfigBuilder()
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response};
  };
  updatePartnerConfig = async (actions: any) => {
    const {body, pagination} = actions.payload;
    const makeUpdatePartnerConfigRequest =
      new UpdatePartnerConfigRequestBuilder().data(body).build();
    const client = new Client(token);
    await client.execute(makeUpdatePartnerConfigRequest);
    return pagination;
  };
}

export default new PartnerConfigRepository();
